var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "plan-feature" } }, [
    _c("div", { staticClass: "feature" }, [
      _c("div", { staticClass: "feature-title" }, [_vm._v("System Feature")]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "feature-delete",
          on: {
            click: function ($event) {
              return _vm.$emit("close")
            },
          },
        },
        [_c("span", { staticClass: "material-icons" }, [_vm._v("close")])]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "feature-form" }, [
      _c("div", { staticClass: "feature-item" }, [
        _c("div", { staticClass: "feature-label" }, [
          _vm._v("Ticket Receiving Limit"),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c("a-input", {
              staticClass: "plan-input",
              attrs: { min: 0, type: "number" },
              model: {
                value: _vm.featureForm.ticketReceivingLimit,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "ticketReceivingLimit", $$v)
                },
                expression: "featureForm.ticketReceivingLimit",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feature-item" }, [
        _c("div", { staticClass: "feature-label" }, [
          _vm._v("Ready Contents Limit"),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c("a-input", {
              staticClass: "plan-input",
              attrs: { min: 0, type: "number" },
              model: {
                value: _vm.featureForm.readyContentsLimit,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "readyContentsLimit", $$v)
                },
                expression: "featureForm.readyContentsLimit",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feature-item" }, [
        _c("div", { staticClass: "feature-label" }, [
          _vm._v("Department Limit"),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c("a-input", {
              staticClass: "plan-input",
              attrs: { min: 0, type: "number" },
              model: {
                value: _vm.featureForm.departmentLimit,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "departmentLimit", $$v)
                },
                expression: "featureForm.departmentLimit",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feature-item" }, [
        _c("div", { staticClass: "feature-label" }, [_vm._v("Role Limit")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c("a-input", {
              staticClass: "plan-input",
              attrs: { min: 0, type: "number" },
              model: {
                value: _vm.featureForm.roleLimit,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "roleLimit", $$v)
                },
                expression: "featureForm.roleLimit",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feature-item" }, [
        _c("div", { staticClass: "feature-label" }, [
          _vm._v("Max Disk Boyutu (Byte) (1GB = 1 * 1024 * 1024 * 1024)"),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c("a-input", {
              staticClass: "plan-input",
              attrs: { min: 0, type: "number" },
              model: {
                value: _vm.featureForm.maxDiskSize,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "maxDiskSize", $$v)
                },
                expression: "featureForm.maxDiskSize",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feature-item" }, [
        _c("div", { staticClass: "feature-label" }, [_vm._v("Free AI Token")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c("a-input", {
              staticClass: "plan-input",
              attrs: { min: 0, type: "number" },
              model: {
                value: _vm.featureForm.freeAIToken,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "freeAIToken", $$v)
                },
                expression: "featureForm.freeAIToken",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feature-item" }, [
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.readyContentsImage,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "readyContentsImage", $$v)
                  },
                  expression: "featureForm.readyContentsImage",
                },
              },
              [_vm._v("Hazır İçerik Resim Ekleme")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.chatAndNotification,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "chatAndNotification", $$v)
                  },
                  expression: "featureForm.chatAndNotification",
                },
              },
              [_vm._v("Chat and Notification")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.chatBalloonCustomization,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "chatBalloonCustomization", $$v)
                  },
                  expression: "featureForm.chatBalloonCustomization",
                },
              },
              [_vm._v("Chat Ballon Customization")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.removeSupsisLogo,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "removeSupsisLogo", $$v)
                  },
                  expression: "featureForm.removeSupsisLogo",
                },
              },
              [_vm._v("Remove Supsis Logo")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.databaseConnection,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "databaseConnection", $$v)
                  },
                  expression: "featureForm.databaseConnection",
                },
              },
              [_vm._v("Database Connection")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.singlePanelAccess,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "singlePanelAccess", $$v)
                  },
                  expression: "featureForm.singlePanelAccess",
                },
              },
              [_vm._v("Singel Panel Access")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.ticketSystem,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "ticketSystem", $$v)
                  },
                  expression: "featureForm.ticketSystem",
                },
              },
              [_vm._v("Ticket System")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.visitorStartChat,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "visitorStartChat", $$v)
                  },
                  expression: "featureForm.visitorStartChat",
                },
              },
              [_vm._v("Ziyaretci Chat Başlatma")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.chatbotEntegration,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "chatbotEntegration", $$v)
                  },
                  expression: "featureForm.chatbotEntegration",
                },
              },
              [_vm._v("Chatbot Entegrasyonu")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.teamChatEntegration,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "teamChatEntegration", $$v)
                  },
                  expression: "featureForm.teamChatEntegration",
                },
              },
              [_vm._v("Takım Konuşması Entegrasyonu")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.whatsappEntegration,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "whatsappEntegration", $$v)
                  },
                  expression: "featureForm.whatsappEntegration",
                },
              },
              [_vm._v("Whatsapp Entegrasyonu")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.instagramEntegration,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "instagramEntegration", $$v)
                  },
                  expression: "featureForm.instagramEntegration",
                },
              },
              [_vm._v("Instagram Entegrasyonu")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.messengerEntegration,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "messengerEntegration", $$v)
                  },
                  expression: "featureForm.messengerEntegration",
                },
              },
              [_vm._v("Messager Entegrasyonu")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.telegramEntegration,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "telegramEntegration", $$v)
                  },
                  expression: "featureForm.telegramEntegration",
                },
              },
              [_vm._v("Telegram Entegrasyonu")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.mailEntegration,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "mailEntegration", $$v)
                  },
                  expression: "featureForm.mailEntegration",
                },
              },
              [_vm._v("Mail Entegrasyonu")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.smsEntegration,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "smsEntegration", $$v)
                  },
                  expression: "featureForm.smsEntegration",
                },
              },
              [_vm._v("SMS Entegrasyonu")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.webhookEntegration,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "webhookEntegration", $$v)
                  },
                  expression: "featureForm.webhookEntegration",
                },
              },
              [_vm._v("WebHook Entegrasyonu")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.calenderEntegration,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "calenderEntegration", $$v)
                  },
                  expression: "featureForm.calenderEntegration",
                },
              },
              [_vm._v("Takvim Entegrasyonu")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.calendarWebFeature,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "calendarWebFeature", $$v)
                  },
                  expression: "featureForm.calendarWebFeature",
                },
              },
              [_vm._v("Takvim Web Özelliği")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.taskManagementEntegration,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "taskManagementEntegration", $$v)
                  },
                  expression: "featureForm.taskManagementEntegration",
                },
              },
              [_vm._v("Task Yönetimi")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.dataProtect,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "dataProtect", $$v)
                  },
                  expression: "featureForm.dataProtect",
                },
              },
              [_vm._v("Veri Güvenliği")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.accessAllAgent,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "accessAllAgent", $$v)
                  },
                  expression: "featureForm.accessAllAgent",
                },
              },
              [_vm._v("Tüm Temsilciler için Erişim")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.readyContents,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "readyContents", $$v)
                  },
                  expression: "featureForm.readyContents",
                },
              },
              [_vm._v("Hazır İçerikler")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.allEntegrations,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "allEntegrations", $$v)
                  },
                  expression: "featureForm.allEntegrations",
                },
              },
              [_vm._v("Tüm Entegrasyonlar")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.permissionControl,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "permissionControl", $$v)
                  },
                  expression: "featureForm.permissionControl",
                },
              },
              [_vm._v("Yetkilendirme Özellikleri")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.autoRezervation,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "autoRezervation", $$v)
                  },
                  expression: "featureForm.autoRezervation",
                },
              },
              [_vm._v("Otomatik Rezervasyon")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.flexibleBilling,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "flexibleBilling", $$v)
                  },
                  expression: "featureForm.flexibleBilling",
                },
              },
              [_vm._v("Esnek Faturalandırma")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.accessControl,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "accessControl", $$v)
                  },
                  expression: "featureForm.accessControl",
                },
              },
              [_vm._v("Erişim Kontrolü")]
            ),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }